import React from 'react';
import { faqs } from '../data/mock';
import { useTheme } from '../context/ThemeContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const { isDark } = useTheme();
  
  return (
    <section id="faq" className={`relative py-24 ${isDark ? 'bg-stone-900' : 'bg-white'}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-amber-500" />
            <span className="text-amber-500 font-medium uppercase tracking-wider text-sm">FAQ</span>
            <div className="h-px w-12 bg-amber-500" />
          </div>
          
          <h2 className={`text-4xl sm:text-5xl font-bold mb-6 ${isDark ? 'text-stone-100' : 'text-stone-800'}`}>
            Frequently Asked Questions
          </h2>
          
          <p className={`text-lg ${isDark ? 'text-stone-400' : 'text-stone-600'}`}>
            Everything you need to know about Unshackled Living.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className={`border rounded-xl px-6 transition-colors ${
                isDark 
                  ? 'bg-stone-950 border-stone-800 data-[state=open]:border-amber-500/30' 
                  : 'bg-stone-50 border-stone-200 data-[state=open]:border-amber-500/50'
              }`}
            >
              <AccordionTrigger className={`text-left font-medium py-6 text-lg [&[data-state=open]]:text-amber-500 ${
                isDark 
                  ? 'text-stone-100 hover:text-amber-400' 
                  : 'text-stone-800 hover:text-amber-600'
              }`}>
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className={`pb-6 leading-relaxed ${isDark ? 'text-stone-400' : 'text-stone-600'}`}>
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
